import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { IHelpCategoryData } from '@/interfaces/help';
import { Box, Button, Drawer, List, ListItem, ListItemText } from '@mui/material';
import he from 'he';
import { useRouter } from 'next/router';

interface Props {
    categories: IHelpCategoryData[];
    setDrawerOpen?: (open: boolean) => void;
  
}

export default function MenuCategoryList({ categories, setDrawerOpen }: Props) {

    const router = useRouter();
    const { slug } = router.query;
    const [expanded, setExpanded] = React.useState<string | false>(false);
    



    const handleChange =
        (panel: string, categorySlug: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);

            if (!setDrawerOpen) {
                if (isExpanded) {
                    
                    router.push({
                        pathname: router.pathname,
                        query: { slug: categorySlug },
                    }, undefined, { shallow: true });
                }
               
            }
        };

    const handleSubCategoryClick = (categorySlug: string, subCategorySlug?: string) => {
        const newSlug = subCategorySlug ? `${categorySlug}/${subCategorySlug}` : categorySlug;
        router.push({
            pathname: router.pathname,
            query: { slug: newSlug.split('/') },
        }, undefined, { shallow: true });

        if (typeof setDrawerOpen === 'function') {
            setDrawerOpen(false);
        }
    };

    React.useEffect(() => {
        if (slug && Array.isArray(slug)) {
            const matchedCategoryIndex = categories?.findIndex(
                (category) => category.category_slug === slug[0]
            );

            if (matchedCategoryIndex !== -1) {
                setExpanded(`panel${matchedCategoryIndex}`);
            }
        }
    }, [slug, categories]);

    return (
        <Box sx={{ padding: 2 }}>
            {categories?.map((category, index) => (
                <Accordion
                    key={category.id}
                    expanded={expanded === `panel${index}`}
                    onChange={handleChange(`panel${index}`, category.category_slug)}
                    sx={{
                        borderBottom: '1px solid #ccc',
                        boxShadow: 'none',
                        '&:before': {
                            display: 'none',
                        },
                        py: 1,
                        '&:hover': {
                            color: '#DB5A00',
                        },
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                        sx={{
                            '& .MuiAccordionSummary-content.Mui-expanded': {
                                margin: 0,
                            },
                        }}
                    >
                        <Typography
                        sx={{
                                fontFamily: "NotoSans-SemiBold, NotoSansThai-SemiBold !important",
                        }}
                        >{he.decode(category.category_title)}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {category.sub_category && category.sub_category.length > 0 ? (
                            <ul style={{ margin: 0 }}>
                                {category.sub_category.map((sub) => (
                                    <li
                                        key={sub.id}
                                        onClick={() => handleSubCategoryClick(category.category_slug, sub.category_slug)}
                                        style={{
                                            color: slug && slug.includes(sub.category_slug) ? '#DB5A00' : '#717275',
                                            cursor: 'pointer',
                                            transition: 'color 0.3s',
                                        }}
                                        className="hover-effect"
                                    >
                                        <Typography
                                            sx={{
                                                color: 'inherit',
                                                my: 1,
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    color: '#DB5A00',
                                                },
                                            }}
                                        >
                                            {he.decode(sub.sub_category_title)}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <Typography sx={{color:"#717275"}}>ไม่มี หมวดหมู่ย่อย</Typography>
                        )}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Box>
    );
}
